"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatErrorResponse = exports.formatResponse = void 0;
/**
 * Возвращает ответ
 */
function formatResponse(response) {
    return { data: response.data };
}
exports.formatResponse = formatResponse;
/**
 * Возвращает ответ с ошибкой
 */
function formatErrorResponse(error) {
    const { response } = error;
    let message = 'Something went wrong';
    if (response) {
        const { data: { errors, message: messageResponse } } = response;
        if (response.data.printError !== undefined) {
            message = response.data.printError;
        }
        if (errors) {
            return {
                message: messageResponse || message,
                errors: getErrors(errors),
            };
        }
    }
    return { message };
}
exports.formatErrorResponse = formatErrorResponse;
/**
 * Возвращает ошибки
 */
function getErrors(errors) {
    return Object.keys(errors).reduce((carry, name) => {
        carry[name] = getFormattedErrorMessage(errors[name]);
        return carry;
    }, {});
}
/**
 * Возвращает форматированные ошибки
 */
function getFormattedErrorMessage(message) {
    if (Array.isArray(message)) {
        return getFormattedErrorMessage(message[0]);
    }
    return message;
}
